export enum Routes {
  FleetTireRouter = '*',
  FleetTireSetSearchPageRouter = '/fleet/tire/set/search',
  FleetTireSetDetailPageRouter = '/fleet/tire/set/:id/detail/',
  FleetTireSetDocumentSearchPageRouter = '/fleet/tire/set/:id/documents/',
  FleetTireSearchPageRouter = '/fleet/tire/search',
  FleetTireDetailPageRouter = '/fleet/tire/:id/detail/',
  FleetTireEditPageRouter = '/fleet/tire/:id/edit/',
  FleetTireCreatePageRouter = '/fleet/tire/new',
  
}


